import React from "react";

const Notification = ({ show, type, message }) => {
  if (!show) return null;

  const bgColor = type === "success" ? "bg-blue-500" : "bg-red-500";

  return (
    <div className={`fixed top-4 right-4 z-50 px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 transition-all duration-500 ${bgColor} text-white`}
    >
      <span>{message}</span>
    </div>
  );
};

export default Notification;